<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { ref, onMounted } from "vue";
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    hotelTransfer: Object,
    hotelsById: Object,
    flash: Object,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'transfers';

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const TransferAddform = useForm({
    vessel: null,
    hotel_id: props.hotelsById.id,
});

const TransferAddformSubmit = () => {
    TransferAddform.post('/transfers/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function deleteTransfer(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this object will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/transfers/delete/' + value;
            }, 300);

            $toast.success('Transfer deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

const FormReset = () => {
    TransferAddform.reset();
    TransferAddform.clearErrors();
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "sweetalert2/dist/sweetalert2.min.css";
</style>

<template>
    <AppLayout title="Hotel Transfers" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-0">
                <div class="card">
                    <h5 class="card-header">Hotel Transfers</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="added-cards">
                                    <div class="bg-lighter rounded-2 p-3 mb-3"
                                        v-for="(transfers, index) in hotelTransfer" :key="transfers.id"
                                        style="border: 1px solid #8592a3;">
                                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                                            <div class="card-information me-2">
                                                <div class="d-flex align-items-center mb-1 flex-wrap gap-2">
                                                    <h6 class="mb-0 me-2">{{ transfers.vessel }}</h6>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column text-start text-sm-end"
                                                v-if="$page.props.user.permissions.includes('remove-transfers')">
                                                <div class="d-flex order-sm-0 order-1 mt-sm-0 mt-3">
                                                    <Link class="btn btn-label-secondary" href="#"
                                                        @click="deleteTransfer(transfers.id)" preserve-scroll replace>
                                                    Delete
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="text-center mt-4 mx-3 mx-md-0">
                                    <img src="/ui/img/illustrations/boat.jpg" class="img-fluid" alt="meals" width="350">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="hotelTransferModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Transfers</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="TransferAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="name" class="form-label"><b>Vessel</b></label>
                                    <select class="form-select" name="vessel" v-model="TransferAddform.vessel"
                                        :class="{ 'is-invalid': TransferAddform.errors.vessel }">
                                        <option disabled="disabled" selected="selected">Select vessel ...</option>
                                        <option value="car">Car</option>
                                        <option value="Domestic Flight">Domestic Flight</option>
                                        <option value="Luxury Boat">Luxury Boat</option>
                                        <option value="Sea Plane">Sea Plane</option>
                                        <option value="Speed Boat">Speed Boat</option>
                                        <option value="Van">Van</option>
                                        <option value="Domestic Flight + Seaplane">Domestic Flight + Seaplane</option>
                                        <option value="Domestic Flight + Speedboat">Domestic Flight + Speedboat</option>
                                        <option value="Seaplane + Speedboat">Seaplane + Speedboat</option>
                                    </select>
                                    <div v-if="TransferAddform.errors.vessel" class="invalid-feedback">
                                        <div v-text="TransferAddform.errors.vessel">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>